import { can, PortalPermissions } from "../../../../../config/permissions";
import React, {ChangeEvent, FocusEvent, useEffect, useState} from 'react';
import { withFormik } from 'formik';
import {toast} from "react-toastify";
import { Row } from 'antd';
import Select from 'antd/lib/select';
import schema from './schema';
import DatePickerField from '../../../../../components/DatePicker';
import {
  DateView,
  Button,
  Form,
  Label,
  ValueCard,
  FilterRow,
  FilterContainer, ButtonSalvar, Col,
} from './styles';
import {
  ILiveTransactionsFilterProps,
  PainelVendasFilterProps,
} from '../../../../../global/dataTransferObjects/transacoesTempoReal';
import { ApplySignatureDiscountsResult, FormProps, IFormProps } from '../../types';
import { formatDate } from '../../../../../utils/formatDate';
import useGetMe from '../../../../../hooks/useCurrentUser'
import PainelDePagamentosService from "../../service/PainelDePagamentosService";
import {getErrorMessage} from "../../../../../utils/getErrorMessage";
import {Modal} from "../modal";
import {PaymentLog} from "../../../painelDeVendas/types";
const painelDePagamentosService = new PainelDePagamentosService();
const FormFilter: React.FC<FormProps> = (props: FormProps) => {
  const user = useGetMe();
  const { handleSubmit, liveTransactions, externalLiveTransactions, loading, setLoading, filter, totalGross, totalLiquid, bulkFlags } = props;
  const [bandeira, setBandeira] = useState('');
  const [tipoPagamento, setTipoPagamento] = useState('0');
  const [businessName, setBusinessName] = useState('');
  const [merchantId, setMerchantId] = useState<string>('');
  const [statusPagamento, setStatusPagamento] = useState<string>("");
  const [acquirer, setAcquirer] = useState(-1);
  const [initialDate, setInitialDate] = useState<string | Date>('');
  const [finalDate, setFinalDate] = useState<string | Date>('');
  const [initialDateFilterType, setInitialDateFilterType] = useState<string>('text');
  const [finalDateFilterType, setFinalDateFilterType] = useState<string>('text');
  const [paid, setPaid] = useState<boolean | null>(false);
  const [anticipationIncluded, setAnticipationIncluded] = useState<boolean | null>(null);
  const [isModalShowing, setIsModalShowing] = useState<boolean>(false);
  const [modalConfirmation, setModalConfirmation] = useState<boolean>(false);
  const [saveType, setSaveType] = useState<string>("");
  const [lastDebitSignUpdate, setLastDebitSignUpdate] = useState<string>('');
  const [lastCreditSignUpdate, setLastCreditSignUpdate] = useState<string>('');
  const [lastPixSignUpdate, setLastPixSignUpdate] = useState<string>('');
  const [centralizedLiquidationEnabled, setCentralizedLiquidationEnabled] = useState<boolean | null>(null);
  const [discountSummary, setDiscountSummary] = useState<ApplySignatureDiscountsResult | null>(null);


  useEffect(() => {
    props.setFieldValue('initialDate', new Date());
    props.setFieldValue('finalDate', new Date());
  }, []);

  const formatMoney = (value: number) => {
    const formattedValue = (value).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return formattedValue;
  };

  function formatDateWithTimezoneOffset(dateStr?: string) {
    if (dateStr) {
      // Converte a string para um objeto Date
      const [month, day, yearAndTime] = dateStr.split('/');
      const [year, time] = yearAndTime.split(' ');
      const isoFormat = `${year}-${month}-${day}T${time}`;
      const date = new Date(isoFormat);

      // Ajusta o fuso horário subtraindo 3 horas
      date.setHours(date.getHours() - 3);

      // Formata os componentes da data
      const dd = String(date.getDate()).padStart(2, '0');
      const MM = String(date.getMonth() + 1).padStart(2, '0'); // Mês é base 0
      const yyyy = date.getFullYear();
      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      const ss = String(date.getSeconds()).padStart(2, '0');

      // Monta a string final
      return `${dd}/${MM}/${yyyy} ${hh}:${mm}:${ss}`;
    }

    return '';
  }

  const getValorVendaTotal = () => formatMoney(totalGross ?? 0);

  const getValorLiquidoTotal = () => formatMoney(totalLiquid ?? 0);

  const handleChangeTipoPagamento = (value: string) => {
    setTipoPagamento(value);
    props.setFieldValue('tipoPagamento', value);
  };

  const handleBusinessNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setBusinessName(event.target.value);
    props.setFieldValue('businessName', event.target.value);
  };

  const handleMerchantId = (event: ChangeEvent<HTMLInputElement>) => {
    setMerchantId(event.target.value);
    props.setFieldValue('merchantId', event.target.value);
  };

  const handleChangeAcquirer = (value: number) => {
    setAcquirer(Number(value));
    props.setFieldValue('acquirer', Number(value));
  };

  const handleInitialDate = (event: ChangeEvent<HTMLInputElement>) => {
    setInitialDate(event.target.value);
    props.setFieldValue('initialDate', event.target.value);
  };

  const handleFinalDate = (event: ChangeEvent<HTMLInputElement>) => {
    setFinalDate(event.target.value);
    props.setFieldValue('finalDate', event.target.value);
  };

  const handleChangePaid = (value: boolean | null) => {
    setPaid(value);
    props.setFieldValue('paid', value);
  };

  const handleChangeAnticipation = (value: boolean | null) => {
    setAnticipationIncluded(value);
    props.setFieldValue('anticipationIncluded', value);
  };

  const handleChangeCentralizedLiquidation = (value: boolean | null) => {
    setCentralizedLiquidationEnabled(value);
    props.setFieldValue('centralizedLiquidationEnabled', value);
  };

  const atualizaPagamentos = async () => {
    setLoading(true);

    const applyToAll = bulkFlags && Object.keys(bulkFlags).length > 0 ? bulkFlags : null;

    let tempExternalLiveTransactions = externalLiveTransactions.map((payment) => {
      return {
        merchant: payment.merchant,
        pixPago: payment.pixPago,
        creditoPago: payment.creditoPago,
        debitoPago: payment.debitoPago
      }
    });

    try {
      await painelDePagamentosService.updatePagamentosExternos(filter, tempExternalLiveTransactions, applyToAll);
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);

      if (errorMessage === 'Request failed with status code 401') {
        window.location.assign(`${window.location.origin}/login`);
      }
    } finally {
      setLoading(false);
    }
  }

  const atualizaDescontos = async () => {
    setLoading(true);
    setDiscountSummary(null);

    try {
      // O Flux aplica o desconto de TODOS os merchants do filtro e grava no GCB.
      const result = await painelDePagamentosService.applySignatureDiscounts(filter);

      await painelDePagamentosService.updateSignatureLog(filter);

      setDiscountSummary(result);
      toast.success(
        `${result.merchantsDiscounted} estabelecimento(s) descontado(s) — total ${formatMoney(result.totalDiscounted)}`
      );
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
      toast.error('Não foi possível aplicar os descontos. Nada foi salvo por este clique.');

      if (errorMessage === 'Request failed with status code 401') {
        window.location.assign(`${window.location.origin}/login`);
      }
    } finally {
      setLoading(false);
    }
  }

  const handleSaveClick = () => {
    setSaveType("pagamentos")
    setIsModalShowing(true);
  };

  const handleSaveBillingClick = () => {
    if(centralizedLiquidationEnabled !== true)
    {
      setSaveType("descontos")
      setIsModalShowing(true);
    }
  };

  const handleModalConfirmation = (confirmed: boolean) => {
    setIsModalShowing(false);

    if (confirmed) {
      if (saveType === "pagamentos") atualizaPagamentos();
      else if (saveType === "descontos") {
        atualizaDescontos().then(response => handleUpdateLogs());
      }
    }
  };

  const handleUpdateLogs = async  () => {
    try {
      const response = await painelDePagamentosService.getPaymentsLog();
      const paymentsLogs: PaymentLog[] = response.data.response;

      setLastDebitSignUpdate('');
      setLastCreditSignUpdate('');
      setLastPixSignUpdate('');

      paymentsLogs.forEach((log) => {
        if (log.productName === '1') setLastDebitSignUpdate(log.paymentUpdateDate);
        if (log.productName === '2') setLastCreditSignUpdate(log.paymentUpdateDate);
        if (log.productName === '3') setLastPixSignUpdate(log.paymentUpdateDate);
      });

    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleUpdateLogs();
  }, []);

  const handleInitialDateFocus = (event: FocusEvent<HTMLInputElement>) => {
    setInitialDateFilterType('date');

    if (!event.target.value) {
      const now = new Date();
      const formattedMidnight = now.toISOString().split('T')[0]; // "YYYY-MM-DD"

      event.target.value = formattedMidnight;
      setInitialDate(formattedMidnight);
      props.setFieldValue('initialDate', formattedMidnight);
    }
  };

  const handleFinalDateFocus = (event: FocusEvent<HTMLInputElement>) => {
    setFinalDateFilterType('date');

    if (!event.target.value) {
      const now = new Date();
      const formattedMidnight = now.toISOString().split('T')[0]; // "YYYY-MM-DD"

      event.target.value = formattedMidnight;
      setFinalDate(formattedMidnight);
      props.setFieldValue('finalDate', formattedMidnight);
    }
  };

  return (
  <>
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {/* Linha superior: Cards + botões */}
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        <ValueCard>
          <div>
            <p style={{ fontWeight: 'bolder' }}>Valor Líquido: </p>
            <p>{getValorLiquidoTotal()}</p>
          </div>
          <div>
            <p style={{ fontWeight: 'bolder' }}>Valor das Vendas: </p>
            <p>{getValorVendaTotal()}</p>
          </div>
        </ValueCard>

        <div>
          {can(PortalPermissions.transacoes.pagamentos.alterarStatus) && (
            <ButtonSalvar
              onClick={handleSaveClick}
              style={{ marginBottom: '25px', width: '150px', alignSelf: 'start' }}
            >
              Salvar
            </ButtonSalvar>
          )}
        </div>

        <div>
          <ButtonSalvar
            onClick={handleSaveBillingClick}
            style={{ marginBottom: '25px', alignSelf: 'start', marginLeft: '8px' }}
          >
            Salvar Descontos
          </ButtonSalvar>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: '16px',
          marginTop: '12px',
          fontSize: '14px',
        }}
      >
        <div><strong>Último desconto débito:</strong> {formatDateWithTimezoneOffset(lastDebitSignUpdate)}</div>
        <div><strong>Último desconto crédito:</strong> {formatDateWithTimezoneOffset(lastCreditSignUpdate)}</div>
        <div><strong>Último desconto pix:</strong> {formatDateWithTimezoneOffset(lastPixSignUpdate)}</div>
      </div>

      {discountSummary && (
        <div
          style={{
            marginTop: '12px',
            padding: '12px 16px',
            border: '1px solid #d9d9d9',
            borderRadius: '4px',
            fontSize: '14px',
            lineHeight: '22px',
          }}
        >
          <div>
            <strong>
              {discountSummary.merchantsDiscounted} estabelecimento(s) descontado(s)
            </strong>
            {' — total descontado '}
            <strong>{formatMoney(discountSummary.totalDiscounted)}</strong>
          </div>
          <div>
            {`${discountSummary.merchantsInScope} estabelecimento(s) no filtro, `}
            {`${discountSummary.merchantsWithPendingSignatures} com assinatura pendente `}
            {`(${formatMoney(discountSummary.totalPendingInScope)}, incluindo cobranças de meses anteriores).`}
          </div>
          {(discountSummary.merchantsPartiallyDiscounted > 0 ||
            discountSummary.merchantsSkippedWithoutLiquid > 0) && (
            <div>
              {`${discountSummary.merchantsPartiallyDiscounted} descontado(s) parcialmente (líquido menor que a assinatura) e `}
              {`${discountSummary.merchantsSkippedWithoutLiquid} sem líquido para descontar.`}
            </div>
          )}
        </div>
      )}
    </div>

    <Form onSubmit={handleSubmit}>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>
      <Row gutter={16}>
        <Col>
          <input type={initialDateFilterType} name="initDate" onFocus={handleInitialDateFocus} onChange={handleInitialDate} placeholder="Data inicial" />
        </Col>
        <Col>
          <input type={finalDateFilterType} name="finalDate" onFocus={handleFinalDateFocus} onChange={handleFinalDate} placeholder="Data final" />
        </Col>
        <Col>
          <Select
            defaultValue="0"
            style={{ width: '100%' }}
            onChange={handleChangeTipoPagamento}
            options={[
              { value: '0', label: 'Tipo pagamento' },
              { value: '1', label: 'Débito' },
              { value: '2', label: 'Crédito' },
              { value: '3', label: 'Pix' },
            ]}
          />
        </Col>
        <Col>
          <input placeholder="Cod. Lojista" onChange={handleMerchantId} />
        </Col>
        <Col>
          <input placeholder="Empresa" onChange={handleBusinessNameChange} />
        </Col>
        <Col>
          <Select
            defaultValue={-1}
            style={{ width: '100%' }}
            onChange={handleChangeAcquirer}
            options={[
              { value: -1, label: 'Adquirente' },
              { value: 3, label: 'Adiq' },
              { value: 10, label: 'Rede' },
              { value: 99, label: 'Valori' },
            ]}
          />
        </Col>
        <Col>
          <Select
            defaultValue={false}
            style={{ width: '100%' }}
            onChange={handleChangePaid}
            options={[
              { value: null, label: 'Status Pagamento' },
              { value: true, label: 'Pago' },
              { value: false, label: 'Pendente' },
            ]}
          />
        </Col>
        <Col>
          <Select
            defaultValue={null}
            style={{ width: '100%' }}
            onChange={handleChangeAnticipation}
            options={[
              { value: null, label: 'Antecipação' },
              { value: true, label: 'Antecipado' },
              { value: false, label: 'Não Antecipado' },
            ]}
          />
        </Col>

        <Col>
          <Select
            defaultValue={null}
            style={{ width: '100%' }}
            onChange={handleChangeCentralizedLiquidation}
            options={[
              { value: null, label: 'Liquidação Centralizada' },
              { value: true, label: 'Sim' },
              { value: false, label: 'Não' },
            ]}
          />
        </Col>
        <Col>
          <Button htmlType="submit">
            Consultar
          </Button>
        </Col>
      </Row>
    </Form>

    <Modal
      isShowing={isModalShowing}
      saveType={saveType}
      modalData={filter}
      onConfirmation={handleModalConfirmation}
    />
  </>
)

}
export default withFormik<IFormProps, PainelVendasFilterProps>({
  mapPropsToValues: (): PainelVendasFilterProps => ({
    initialDate: '',
    finalDate: '',
    tipoPagamento: '0',
    businessName: '',
    merchantId: '',
    acquirer: -1,
    paid: false,
    anticipationIncluded: null,
    centralizedLiquidationEnabled: null
  }),
  validationSchema: schema,
  handleSubmit: (values, { props }) => {
    if (values.initialDate == null || values.finalDate == null) {
      toast.error('Preencha as datas corretamente!')
      return;
    }

    const todayStr = new Date().toISOString().split('T')[0];

    const normalizeDate = (value: any): string => {
      if (!value) return todayStr;
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.split(' ')[0];
      const d = new Date(value);
      d.setHours(0, 0, 0, 0);
      return formatDate(d) ?? todayStr;
    };

    const test = {
      ...values,
      initialDate: normalizeDate(values.initialDate),
      finalDate: normalizeDate(values.finalDate),
    }
    props.onFormSubmit(test);
  },
})(FormFilter);
